export default {
  SHRINK_TO_FIT: 'shrinkToFit',
  EXPAND_TO_FILL: 'expandToFill'
};
